export default __webpack_public_path__ + "static/media/people-keep-benefits-personalized.2c7a2cf8.svg";